import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DataTypeComponent } from '../../data-type-component';
import { PlayerConsentsV2Component } from './v2/player-consents-v2.component';

@Component({
  selector: 'player-consents-component',
  templateUrl: './player-consents.component.html',
  styleUrls: ['./player-consents.component.scss'],
  imports: [
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    MatTooltipModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    PlayerConsentsV2Component,
  ],
})
export class PlayerConsentsComponent extends DataTypeComponent {
  playerId: number;

  constructor() {
    super();
  }

  override setRowData(entity: any) {
    this.playerId = entity.details?.playerId;
  }
}
